//
// MODULE
//

import React from 'react'

import Link from '../Link'
import SnipsLogo from '../Logo'

//
// COMPONENT
//

const HeaderSeeds = () => (
  <header className='header-seeds'>
    <Link href='/' className='mr1'>
      <SnipsLogo />
    </Link>
    <Link className='header-seeds__seeds-link block link--plain' href='/seeds'>
      <img
        className='header-seeds__seeds-icon'
        src='/static/images/icons/seeds_logo.svg'
      />
      <span className='header-seeds__title'>Seeds</span>
    </Link>
  </header>
)

//
// EXPORT
//

export default HeaderSeeds



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/seeds/HeaderSeeds.js